import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExcludeCancelledJobsLookupComponent } from './exclude-cancelled-jobs-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ExcludeCancelledJobsLookupComponent],
  exports: [ExcludeCancelledJobsLookupComponent]
})
export class ExcludeCancelledJobsLookupModule { }
